import moment from 'moment'
import {
    showProfessionField,
    showContractType,
    showEmployedSince,
    showEmployerFields,
} from '../../functional/employment'
import * as Output from '../../Text'
import { Rules } from '../technical';
import { name } from './name';

export const validateEmployment = (field, fields) => {
    if (
        showContractType(fields.professionGroup)
        && (!field || field.length === 0)
    ) {
        return Output.resolve(
            'generic.errors.M001_mandatoryFields',
        );
    }
};

export const validateIndustryOfOccupation = (field, fields) => {
    if (
        showContractType(fields.professionGroup)
        && (!field || field.length === 0 || field === "OTHER")
    ) {
        return Output.resolve(
            'generic.errors.M001_mandatoryFields',
        );
    }
};

export const validateProfession = (field, fields) => {
    if (showProfessionField(fields.professionGroup)) {
        if ((!field || field.length === 0)) {
            return Output.resolve(
                'generic.errors.M001_mandatoryFields',
            )
        }
        if (!/^[\w\- ÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß&.,]*$/.test(field)) {
            return Output.resolve(
                'generic.errors.M002_invalidCharacters',
            )
        }
    }
}

export const validateBusiness = (field, fields) => {
    if (
        showProfessionField(fields.professionGroup)
        && (!field || field.length === 0)
    ) {
        return Output.resolve(
            'generic.errors.M001_mandatoryFields',
        )
    }
};

export const validateEmploymerName = (field, fields) => {
    if (showEmployerFields(fields.professionGroup)) {
        if ((!field || field.length === 0)) {
            return Output.resolve(
                'generic.errors.M001_mandatoryFields',
            )
        }
        if (!/^[\w\- ÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠšß&.,]*$/.test(field)) {
            return Output.resolve(
                'generic.errors.M002_invalidCharacters',
            )
        }
        return Rules.maxLength(35)(field);
    }
};

export const validateEmployedSince = (field, fields) => {
    if (showEmployedSince(fields.professionGroup)) {
        if (field && field.length > 0) {
            const date = moment(field, 'YYYY-MM-DD', true);;
            if (!date.isValid()) {
                return Output.resolve(
                    'generic.errors.M004a_dateFormat')
            }
            const isInPast = date.isBefore(moment(new Date()));
            if (!isInPast) {
                return Output.resolve(
                    'generic.errors.M004b_dateCanNotBeInTheFuture')
            }
        } else {
            return Output.resolve(
                'generic.errors.M001_mandatoryFields')
        }
    }
};

export const validateEmployerLocation = (field, fields) => {

    if (showEmployerFields(fields.professionGroup)) {

        if ((!field || field.length === 0)) {
            return Output.resolve(
                'generic.errors.M001_mandatoryFields',
            )
        }

        if (name(field)) {
            return Output.resolve(
                'generic.errors.M002_invalidCharacters',
            )
        }
        return Rules.maxLength(50)(field);
    }
};

export const professionGroupValidation = (value, fields) => {
    // GFTDE-963 info for selfemployed to decline
    if (value === "SELFEMPLOYED") {
        return Output.resolve('generic.errors.M014_ExcludeSelfemployed');
    }
};

export const employmentLimitValidation = (value, fields) => {

    if (fields.employment === 'limited' || fields.professionGroup === "APPRENTICE") {
        if (value) {
            const date = moment(value, 'YYYY-MM-DD', true);;
            if (!date.isValid()) {
                return Output.resolve(
                    'generic.errors.M004a_dateFormat')
            }
            const isInPast = date.isBefore(moment(new Date()));
            if (isInPast) {
                return Output.resolve(
                    'generic.errors.M004c_dateHaveToBeInTheFuture')
            }
        } else {
            return Output.resolve(
                'generic.errors.M001_mandatoryFields',
            )
        }
    }
};
